import { View } from 'backbone.marionette';
import _ from 'lodash';

import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import RelocationDeliveryScheduleGridView from '../../../../order/views/RelocationDeliveryScheduleGridView/RelocationDeliveryScheduleGridView';
import SaveMFDRelocationDeliverySchedules from '../../../services/SaveMFDRelocationDeliverySchedules';

import tmplRelocationDeliveryView from './RelocationDeliveryView.hbs';

const RelocationDeliveryView = View.extend({
  template: tmplRelocationDeliveryView,

  className: 'relocation-delivery-view',

  ui: {
    fromDeliveryGrid: '.from-delivery-grid',
    toDeliveryGrid: '.to-delivery-grid',
    deliveryInfoError: '.delivery-info-error'
  },

  regions: {
    fromDeliveryGrid: '@ui.fromDeliveryGrid',
    toDeliveryGrid: '@ui.toDeliveryGrid'
  },

  childViewEvents: {
    'row:item:save': 'onRowSave'
  },

  onRender() {
    // options.editable is defined when viewed in an order package; isReadOnly is defined in a customer order
    const editable = this.options.editable ?? !this.model.get('isReadOnly');

    const toModel = this.model.clone();
    const fromModel = this.model.clone();
    toModel.set('schedules', this.model.get('toDevice'));
    fromModel.set('schedules', this.model.get('fromDevice'));

    const toDeliveryGrid = new RelocationDeliveryScheduleGridView({
      objectTypeCode: 'ORDER',
      objectID: this.model.get('orderId') || this.model.get('orderDetails').orderId,
      gridName: 'toDeliveryScheduleGrid',
      model: toModel,
      editable,
      itPOCExists: true
    });
    this.showChildView('toDeliveryGrid', toDeliveryGrid);

    const fromDeliveryGrid = new RelocationDeliveryScheduleGridView({
      objectTypeCode: 'ORDER',
      objectID: this.model.get('orderId') || this.model.get('orderDetails').orderId,
      gridName: 'fromDeliveryScheduleGrid',
      model: fromModel,
      editable,
      itPOCExists: true
    });
    this.showChildView('fromDeliveryGrid', fromDeliveryGrid);
  },

  validate() {
    let isValid = true;
    const [fromColl, toColl] = this.getDeliveryData();
    const reqFields = [
      'deliveryPOCName',
      'deliveryPOCEmail',
      'deliveryPOCPhone',
      'itPOCName',
      'itPOCEmail',
      'itPOCPhone',
      'addressLine1',
      'buildingFloorNumber',
      'floorNumber',
      'city',
      'regionName',
      'zip'
    ];
    _.each(fromColl.toJSON(), (item) => {
      _.each(reqFields, (field) => {
        if (!item[field] && !item.address[field]) {
          isValid = false;
          this.ui.deliveryInfoError.show();
        }
      });
    });
    _.each(toColl.toJSON(), (item) => {
      _.each(reqFields, (field) => {
        if (!item[field] && !item.address[field]) {
          isValid = false;
          this.ui.deliveryInfoError.show();
        }
      });
    });
    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  getDeliveryData() {
    this.ui.deliveryInfoError.hide();
    this.trigger('no:errors');
    const fromColl = this.getChildView('fromDeliveryGrid').options.collection;
    const toColl = this.getChildView('toDeliveryGrid').options.collection;
    return [fromColl, toColl];
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        "An error occurred while saving this Relocation's delivery information. Try again or contact an administrator if your issue persists."
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  },

  async onRowSave() {
    const coll = this?.getDeliveryData();
    const orderId = this.model.get('orderId') || this.model.get('orderDetails').orderId;
    const formData = {
      fromColl: coll[0].toJSON()[0],
      toColl: coll[1].toJSON()[0],
      orderId
    };
    try {
      await SaveMFDRelocationDeliverySchedules(formData);
      this.showSaveSuccess();
    } catch (err) {
      if (err) {
        this.showSaveError();
      }
    }
  }
});

export default RelocationDeliveryView;
